// replacement for jQuery offset
const offset = (node, value, warning = false) => {
  // if the node has an offsetParent that isn't the body...
  if (node.offsetParent != document.body) {
    // add the node's offsetTop to the value.
    value += node.offsetTop;
    // call the function again, passing the node's offsetParent and the running value.

    if (node.offsetParent === null) {
      if (!warning) {
        console.warn(
          `The offsetParent of ${node.className ||
            node.id} is null. The node's offsetParent may have a position of "fixed" or a display of "none" that could interfere with offset calculations.`
        );
      }

      warning = true;
      return offset(node.parentElement, value, warning);
    } else {
      return offset(node.offsetParent, value);
    }
  } else {
    // if the node is relative to the body, add the offsetTop and return.
    return (value += node.offsetTop);
  }
};

export default offset;
